export class ApprovalAuthorizationRequest {
    authorizationCode: string;
}